const ApiSuffix = {
  // logout: "/api/logout/",
  submitRegForm: "/api/delegate-register/",
  getContact: "/api/delegate-register/?contact=",
  submitAbstract: "/api/abstract-submit/",
  postQuery: "/api/query-form/",
  submitfaculty: "/api/faculty-reg/",
  submitAccommodation: "/api/book-accommodation/",
  nursingReg :"/api/nursing-symposium-crud/"
};

export default ApiSuffix;
